import { render, staticRenderFns } from "./NavPage.vue?vue&type=template&id=39e65f1d&scoped=true&"
import script from "./NavPage.vue?vue&type=script&lang=js&"
export * from "./NavPage.vue?vue&type=script&lang=js&"
import style0 from "./NavPage.vue?vue&type=style&index=0&id=39e65f1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e65f1d",
  null
  
)

export default component.exports